function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 7H8V6h11zM8 15h6.363l1.17-1H8zm-6 3V3h19v5h1V2H1v17h8.736c.038-.043.066-.09.107-.131l.087-.081.922-.788zm15.49-8H8v1h9.106a3.802 3.802 0 0 1 .385-1zM12 21h1v-1h-1zm-8-8h3v3H4zm1 2h1v-1H5zm2-7H4V5h3zM6 6H5v1h1zm18 5.886a4.072 4.072 0 0 1-1.4 2.621 2.805 2.805 0 0 1-2.496.385l-.057-.013-6.661 7.489a1.99 1.99 0 1 1-2.835-2.793c.026-.025 6.462-5.523 7.663-6.552a2.872 2.872 0 0 1 .808-3.317 3.873 3.873 0 0 1 2.843-.635.544.544 0 0 1 .487.46.603.603 0 0 1-.301.606l-1.646 1.285.309.788.63.469 1.708-1.327a.584.584 0 0 1 .652-.06.61.61 0 0 1 .296.594zm-1.396 1.08l-.824.64a.702.702 0 0 1-.853.009l-1.011-.781a.855.855 0 0 1-.09-.152l-.432-1.1a.713.713 0 0 1 .228-.817l.863-.67a2.384 2.384 0 0 0-.85.4 1.898 1.898 0 0 0-.416 2.332.67.67 0 0 1-.134.766c-.019.017-.037.035-7.856 6.716a.986.986 0 0 0 .03 1.373 1.015 1.015 0 0 0 1.4 0l6.745-7.585a.687.687 0 0 1 .787-.214l.142.035a1.856 1.856 0 0 0 1.652-.2 2.515 2.515 0 0 0 .62-.752zM7 12H4V9h3zm-1-2H5v1h1z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});

function SvgSystemHealthMonitoring(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemHealthMonitoring);
export default __webpack_public_path__ + "static/media/system-health-monitoring.98536e88.svg";
export { ForwardRef as ReactComponent };